var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmittedtoFleet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Submitted_to_Fleet"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Submitted_to_Fleet",
    "data-name": "Submitted to Fleet",
    clipPath: "url(#clip-Submitted_to_Fleet)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2.568 0.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11759",
    "data-name": "Group 11759",
    transform: "translate(0 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11758",
    "data-name": "Group 11758",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22193",
    "data-name": "Path 22193",
    d: "M12.8,15.784a1.245,1.245,0,0,1-.784,1.006,1.008,1.008,0,0,1-.389.086c-3.482,0-6.964,0-10.446-.006A1.275,1.275,0,0,1,.035,15.851a1.857,1.857,0,0,1-.027-.442C.009,11.269.017,7.129,0,2.989a1.359,1.359,0,0,1,.929-1.3,1.83,1.83,0,0,1,.489-.074c.678,0,1.355,0,2.033.005.144,0,.18-.039.175-.178-.011-.313,0-.627,0-.941,0-.344.134-.481.483-.494.031,0,.063,0,.094,0H8.642a.775.775,0,0,1,.169,0c.358.079.435.22.44.548,0,.3.007.6,0,.9,0,.124.032.159.157.157.653-.006,1.305,0,1.957,0a1.425,1.425,0,0,1,1.289.635,1.406,1.406,0,0,1,.21.8q.006,6.135,0,12.27a.929.929,0,0,1-.062.428l-.027,0,.026.025Zm-.744-6.513c0-2.057-.006-4.115.006-6.173a.609.609,0,0,0-.693-.681c-.614.011-1.229,0-1.844,0-.3,0-.319,0-.3.3a.455.455,0,0,1-.5.5C7.64,3.212,6.554,3.22,5.469,3.22c-.489,0-.979,0-1.468,0a.369.369,0,0,1-.245-.1c-.2-.159-.135-.372-.139-.57,0-.093-.019-.128-.123-.128-.7.005-1.406-.006-2.108.008A.57.57,0,0,0,.861,2.7a.655.655,0,0,0-.042.37q0,6.107,0,12.214a1.1,1.1,0,0,1-.017.255.517.517,0,0,0,.462.538H11.4a.65.65,0,0,1,.075,0,.49.49,0,0,0,.5-.276.826.826,0,0,0,.076-.487q.005-3.02,0-6.041ZM6.44,2.42c.62,0,1.24,0,1.86,0,.117,0,.146-.03.144-.145q-.011-.657,0-1.315c0-.129-.04-.154-.16-.154q-1.852.005-3.7,0c-.131,0-.154.043-.153.161.006.432.009.865,0,1.3,0,.142.047.159.17.158.614-.006,1.228,0,1.842,0Z",
    transform: "translate(0 -0.009)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22194",
    "data-name": "Path 22194",
    d: "M176.966,218.187l-.026-.025.027,0v.027Z",
    transform: "translate(-164.167 -202.412)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22195",
    "data-name": "Path 22195",
    d: "M40.67,101.276l-.04.029C40.635,101.284,40.642,101.267,40.67,101.276Z",
    transform: "translate(-37.697 -93.964)",
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22196",
    "data-name": "Path 22196",
    d: "M51.055,103.409a.364.364,0,0,1-.279-.111c-.519-.518-1.039-1.035-1.556-1.556a.408.408,0,0,1,.56-.593c.187.17.362.353.541.531.222.221.445.44.663.665.056.058.087.053.142,0q1.46-1.464,2.922-2.926a.465.465,0,0,1,.276-.154.422.422,0,0,1,.416.227.4.4,0,0,1-.057.45c-.012.014-.026.027-.039.041l-3.293,3.293a.386.386,0,0,1-.3.134Z",
    transform: "translate(-45.552 -92.095)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedtoFleet);
export default __webpack_public_path__ + "static/media/Submitted to Fleet.d2ec1ae37d7712ec40557cad4ccfa665.svg";
export { ForwardRef as ReactComponent };